import * as yup from 'yup';

export const subscriptionSchema = yup.object().shape({
  subscription_level: yup.string().required('Subscription level is required field'),
  invoice_period: yup.string().required('Invoice period is required field'),
  number_of_users: yup.number().required('Number of users is required field'),
});
